<template>
  <BModal
    ref="detail-modal"
    modal-class="notification-detail-modal modal-dialog-centered d-flex"
    :header-class="[getDialogHeaderClasses, 'font-weight-bold']"
    footer-border-variant="light"
    hide-header-close
  >
    <template #modal-title>
      <div class="d-flex align-items-center">
        <div
          class="notification-icon-circle rounded-circle bg-white d-flex align-items-center justify-content-center mr-2"
          :class="getIconBorderColor(message)"
        >
          <i
            :class="`${getIconClass(
              message
            )} notification-icon fa-lg text-primary`"
          ></i>
        </div>
        <span>{{ message?.detailTitle }}</span>
      </div>
    </template>
    <div v-if="message">
      <vue-editor
        class="reset-style editor-viewer"
        :disabled="true"
        :editor-options="editorOptions"
        v-model="detailBodyModel"
      ></vue-editor>
    </div>

    <template #modal-footer="{ ok }">
      <button
        v-if="message.detailMoreUrl && notificationToBeAccepted"
        type="button"
        class="btn btn-primary"
        @click="openDetailMore"
      >
        {{ $t('app.notifications.find-out-more') }}
      </button>

      <div class="ml-auto d-flex">
        <button
          v-if="
            notificationToBeAccepted &&
            notificationToRead &&
            !isNotificationExpired(message)
          "
          type="button"
          class="btn btn-outline-dark"
          @click="remindLater(ok)"
        >
          {{ $t('app.notifications.remind-me') }}
        </button>

        <button
          v-if="message.detailMoreUrl && !notificationToBeAccepted"
          type="button"
          class="btn btn-primary"
          @click="openDetailMore"
        >
          {{ $t('app.notifications.find-out-more') }}
        </button>

        <button
          type="button"
          class="btn btn-primary"
          @click="markMessageAsRead(ok)"
        >
          {{
            notificationToBeAccepted && notificationToRead
              ? $t('app.notifications.ok-understood')
              : $t('app.forms.close')
          }}
        </button>
      </div>
    </template>
  </BModal>
</template>
<script>
import { VueEditor } from 'vue2-editor'
import notificationsMixin from '~/mixins/notificationsMixin.js'

export default {
  components: {
    VueEditor,
  },
  mixins: [notificationsMixin],
  props: {
    message: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      editorOptions: {
        modules: {
          toolbar: false,
        },
      },
    }
  },
  computed: {
    detailBodyModel: {
      get() {
        return this.message?.detailBody
      },
      set() {},
    },
  },
  methods: {
    showModal() {
      this.$refs['detail-modal'].show()
    },
    openDetailMore() {
      if (this.message?.detailMoreUrl) {
        window.open(this.message.detailMoreUrl, '_blank')
      }
    },
  },
}
</script>
<style scoped>
.notification-detail-modal {
  :deep(.modal-dialog) {
    animation: slideInFromRight 0.3s ease-out;
  }
}

:deep(.modal-dialog) {
  min-width: 80svw !important;
  width: 80svw !important;
}

:deep(.modal-dialog .modal-content .modal-header h5.modal-title) {
  display: flex;
  align-items: center;
}

:deep(.editor-viewer .ql-container) {
  border: none;
}

:deep(.editor-viewer .ql-container .ql-editor) {
  padding: 0;
  min-height: fit-content;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.editor-viewer {
  max-height: 70svh;
  overflow-y: auto;
}

:deep(.modal-footer > .ml-auto > button) {
  margin: 0.25rem;
}

@keyframes slideInFromRight {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
